import React from 'react';
import SessionTime from 'components/InPersonTraining/shared/SessionTime';
import SessionDetails from '../shared/SessionDetails';

const SessionInfo = ({ event, session }) => (
  <>
    <div className="fz-h1 ff-ss lh-1 mb-32">
      {t('in_person_training.invite_users.invite_people_to_event')}{' '}
      <b>{event.name}</b>
    </div>
    <SessionTime
      className="mt-16 mb-16"
      startTime={session.start_time}
      endTime={session.end_time}
      timeZone={session.time_zone}
    />
    <SessionDetails session={session} eventId={event.id} />
  </>
);

export default SessionInfo;
